'use strict';

const siteAlert = require('../components/alert');

/**
 * Shows the wishlist add/remove result.
 * @param {Object} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked to add a product to the wishlist
 */
function displayMessage(data, button) {
    $.spinner().stop();

    siteAlert.show({
        type: data.success ? 'success' : 'error',
        message: data.msg,
        timeout: 5000,
        onHide: function () {
            button.removeAttr('disabled');
        }
    });
}

module.exports = {
    addToWishlist: function () {
        $('.add-to-wish-list').on('click', function (e) {
            e.preventDefault();

            const url = $(this).data('href');
            const button = $(this);
            let pid = $(this).closest('.product-detail').find('.product-id').data('pid');
            let optionId = $(this).closest('.product-detail').find('.product-option').attr('data-option-id');
            let optionVal = $(this).closest('.product-detail').find('.options-select option:selected').attr('data-value-id');

            optionId = optionId || null;
            optionVal = optionVal || null;

            if (!url || !pid) return;

            $.spinner().start();
            $(this).attr('disabled', true);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: {
                    pid: pid,
                    optionId: optionId,
                    optionVal: optionVal
                },
                success: function (data) {
                    displayMessage(data, button);
                },
                error: function (err) {
                    displayMessage(err, button);
                }
            });
        });
    }
};
